// Events are prefixed automatically by the AiTeammateAnalyticsProvider
export const AI_TEAMMATE_EVENTS = {
  DRAWER_OPENED: "Drawer Opened",
  DRAWER_CLOSED: "Drawer Closed",
  NEW_THREAD_CREATED: "New Thread Created",
  THREAD_RESET: "Thread Reset",
  MESSAGE_SENT: "Message Sent",
  PLOT_EXPANDED: "Plot Expanded",
  TABLE_EXPANDED: "Table Expanded",
  TABLE_EXPLAIN_OPENED: "Table Explain Opened",
} as const

export type AiTeammateEventName = typeof AI_TEAMMATE_EVENTS[keyof typeof AI_TEAMMATE_EVENTS]
